import { render, staticRenderFns } from "./TableErrorImportIdpExamFee.vue?vue&type=template&id=6b418c9e&scoped=true"
import script from "./TableErrorImportIdpExamFee.vue?vue&type=script&lang=js"
export * from "./TableErrorImportIdpExamFee.vue?vue&type=script&lang=js"
import style0 from "./TableErrorImportIdpExamFee.vue?vue&type=style&index=0&id=6b418c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b418c9e",
  null
  
)

export default component.exports